import type { ReactNode } from 'react'

interface EmptyStateProps {
  icon: ReactNode
  title: string
  description: string
  children?: ReactNode
  className?: string
}

export function EmptyState({ icon, title, description, children, className = '' }: EmptyStateProps) {
  return (
    <div className={`flex flex-col items-center justify-center py-20 text-center space-y-6 ${className}`}>
      <div className="relative w-16 h-16 overflow-hidden flex items-center justify-center bg-zinc-100 dark:bg-zinc-800 rounded-full">
        {icon}
      </div>
      <div className="max-w-md space-y-2">
        <h3 className="text-2xl font-black text-zinc-900 dark:text-zinc-100">
          {title}
        </h3>
        <p className="text-zinc-500 dark:text-zinc-400">
          {description}
        </p>
      </div>
      {children && (
        <div className="flex flex-row gap-3 mt-2 items-center justify-center">
          {children}
        </div>
      )}
    </div>
  )
}
